import type { ComponentType } from 'react';
import { withRouter as withReactRouter } from 'react-router-dom';
import { withRouter as withSpaRouter } from '@atlassian/react-resource-router';

// Can remove address this loose typing from react-router vs spa-router type mismatch when the JSD SPA is on by default
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const withRouter = (WrappedComponent: ComponentType<any>) =>
	__SPA__ ? withSpaRouter(WrappedComponent) : withReactRouter(WrappedComponent);
